
import borderSrc from '../../assets/claimed-border.svg'
import styles from './ClaimedScreen.module.scss'

export const ClaimedScreen = () => {
  return (
    <div className={styles.frame}>
      <img
        src={borderSrc}
        alt=""
        className={styles.frameBorder}
        aria-hidden
      />

      <p className={styles.subtitle}>$NOT $NOT $NOT</p>
      <div className={styles.amount}>{`Claim\nsuccessfull`}</div>
      <span className={styles.comingSoon}>$NOT $NOT $NOT</span>
    </div>
  )
}
